<h1 mat-dialog-title>
  Vendor Products with Pending FTP
</h1>
<div mat-dialog-content>
  @if (ftpProducts.length === 0) {
    <mat-label>No Pending FTP Transfers</mat-label>
  }
  @if (ftpProducts.length > 0) {
    <mat-form-field>
      <mat-label>Select Products to Send</mat-label>
      <mat-select multiple (selectionChange)="setProduct($event)">
        @for (product of ftpProducts; track product) {
          <mat-option [value]="product.id">{{product.name}} ({{product.count}})</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
<div class="buttons" mat-dialog-actions>
  <button class="okbutton" [disabled]="selectedProducts.length === 0" mat-raised-button color="primary" (click)="onConfirm()">Initiate FTP</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
